// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Chip_wrapper__3lH4-","chip":"Chip_chip__3My14","disabled":"Chip_disabled__31gaO","icon":"Chip_icon__onjRd"};